import dynamic from "next/dynamic";
const NewsGrid1 = dynamic(() => import("@/component/NewsGrid/NewsGrid1"));
import SVG from "react-inlinesvg";
import AdSlot300x250 from "../Ads/AdSlot300x250";
import AdSlot728x90 from "../Ads/AdSlot728x90";
import { useContext, useState } from "react";
import { MasterConfigContext } from "@/context/MasterConfigContext";

const IPLCommonFooter = ({
  categoryNewsListData = null,
  faqData = null,
  isMobileDevice = false,
  showAds = false,
  scrolled = false,
  showContent = false,
  customHeading = null,
  isAsiaCup = false,
  content = null
}) => {
  const masterConfig = useContext(MasterConfigContext);
  const iplKeys = masterConfig["ipl_2025"];
  const asia_cup_keys = masterConfig["sportsEvent"];

  const [readMore, setReadMore] = useState(true);
  return (
    <div>
       {showContent && isAsiaCup&& (
        <>
          <h2 className="flex mt-12 mb-2 gap-2 items-start">
            <span className="bg-[#CC0000] w-2 h-4"></span>
            <span className="text-lg font-semibold -mt-1">
              {"Asia Cup 2025"}
            </span>
          </h2>
          <p className={`text-[#323232] text-sm text-left relative inline`}>
            <p
              dangerouslySetInnerHTML={{ __html: `${content}` }}
              className={`${readMore ? "line-clamp-3" : ""} text-justify`}
            ></p>
            <span
              onClick={() => {
                setReadMore((prev) => !prev);
              }}
              className="cursor-pointer inline -ml-[0.5px]  text-primary text-sm"
            >
              {readMore ? "और देखें >" : "< कम देखें"}
            </span>
          </p>
        </>
      )}
      {faqData && asia_cup_keys?.asiaCupFAQ && (
        <div className="my-4">
          <h2 className="text-lg font-semibold">
            एशिया कप 2025: अक्सर पूछे जाने वाले सवाल (FAQs)
          </h2>
          <section className="flex flex-col gap-1 text-gray-500 text-md font-extralight">
            <p
              className={`${isMobileDevice ? "custom-mb-break" : ""}`}
              dangerouslySetInnerHTML={{
                __html: `${faqData?.content?.description_short}`,
              }}
            />
          </section>
        </div>
      )}
      {categoryNewsListData && categoryNewsListData?.content?.length > 0 && (
        <section className="my-4">
          <div className="flex items-center justify-between mt-8">
            <h2 className="text-lg font-semibold">
              {customHeading ? customHeading : "रिलेटेड न्यूज"}
            </h2>
            <a href="/sports">
              <span className="flex items-center text-sm">
                और देखें
                <SVG
                  className="w-6 h-6 inline ml-2  mt-[-2px]"
                  src="/assets/icons/svg/rightArrowRound.svg"
                />
              </span>
            </a>
          </div>
          <div className="text-16">
            <NewsGrid1
              newsData={categoryNewsListData || null}
              showLiveVideo={false}
              showAd={false}
              isLCP={false}
              isMobileDevice={isMobileDevice}
              liveVideoData={null}
              isResultsPage={true}
            />
          </div>
        </section>
      )}

      {showAds && scrolled && (
        <div className="mx-4">
          <AdSlot300x250
            divId="div-gpt-ad-1659434785315-0"
            minWidth="300px"
            minHeight="250px"
          />
        </div>
      )}

      {showAds && scrolled && (
        <AdSlot728x90
          divId="div-gpt-ad-1707804176041-3"
          minWidth="720px"
          minHeight="90px"
        />
      )}
      {/* description  */}
      {faqData && showContent && (!isAsiaCup) && (
        <>
          <h2 className="flex mt-12 mb-2 gap-2 items-start">
            <span className="bg-[#CC0000] w-2 h-4"></span>
            <span className="text-lg font-semibold -mt-1">IPL 2025</span>
          </h2>
          <p className={`text-[#323232] text-sm text-left relative inline`}>
            <span className={`${readMore ? "line-clamp-2" : ""}`}>
              इंडियन प्रीमियर लीग (IPL) दुनिया की सबसे लोकप्रिय क्रिकेट लीग में
              से एक है। फ्रेंचाइजी वाली यह टी20 क्रिकेट लीग का 18वां सीजन 22
              मार्च से शुरू हुआ था। पिछले चार सालों से आईपीएल में 10 टीमें
              हिस्सा ले रही हैं। इस लीग में खेलती हुई दिख रही लखनऊ सुपर जायंट्स
              और गुजरात टाइटंस नई टीमें हैं, इसके अलावा बाकी 8 टीमें 2008 से ही
              इस लीग से जुडी रही हैं। साल 2024 की तुलना में जब हम 2025 की आईपीएल
              टीमों को देखते हैं. तो इनमें काफी बदलाव नजर आता है. इसका कारण 24
              और 25 नवंबर 2024 को हुए मेगा ऑक्शन (IPL Auction) है. जिसमें कई
              बड़े नामों को उनकी टीम द्वारा रिटेन न करना है. इस बार ऑक्शन में
              कुल 182 खिलाड़ियों नीलामी में शामिल हुए. सभी टीमों में केवल
              खिलाड़ियों में बदलाव नहीं हुए, बल्कि 5 टीमों के कप्तान भी बदल गए
              हैं.
            </span>
            <span
              onClick={() => {
                setReadMore((prev) => !prev);
              }}
              className="cursor-pointer inline -ml-[0.5px]  text-primary text-sm"
            >
              {readMore ? "और देखें >" : "< कम देखें"}
            </span>
          </p>
        </>
      )}
      {/* faqs  */}

      {faqData && iplKeys?.showFAQ && showContent && (!isAsiaCup) &&(
        <div className="my-4">
          <h2 className="text-lg font-semibold">IPL 2025 से जुड़े सवाल जवाब</h2>
          <section className="flex flex-col gap-4 text-gray-500 text-md font-extralight">
            <p
              className={`${isMobileDevice ? "custom-mb-break" : ""}`}
              dangerouslySetInnerHTML={{
                __html: `${faqData?.content?.description_short}`,
              }}
            />
          </section>
        </div>
      )}
     
    </div>
  );
};

export default IPLCommonFooter;
